import { MultiSelectOption } from '@dispatch/shared/types';
import { CheckBoxField, SelectField, TextField } from '@dispatch/web/ui';
import { Grid } from '@mui/material';
import { Control, FieldErrors, FieldValues } from 'react-hook-form';

export const TaskSection = ({
  errors,
  control,
  hasUpsertPermissions,
  inspectionOptions,
  perils,
  taskData,
}: {
  errors: FieldErrors;
  control: Control<FieldValues>;
  hasUpsertPermissions: unknown;
  inspectionOptions?: { title: string; value: string }[];
  perils: MultiSelectOption[];
  taskData?: any /*TaskSummaryResponse*/;
}) => {
  const sloOptions = (): { title: string; value: string | number }[] => {
    const slos = [];
    for (let count = 0; count <= 120; count += 5) {
      slos.push({ title: `${count}`, value: count });
    }
    return [...slos];
  };

  const matchingPeril = perils?.find(
    (x) => x.value === taskData?.$msg?.claim?.peril
  );

  return (
    <>
      <Grid container spacing={2} marginBottom={2} alignItems="end">
        <Grid data-testid="method-of-inspection" size={4}>
          <SelectField
            id="assignment.methodOfInspection"
            name="assignmentHandling.methodOfInspection"
            label="Inspection Method"
            required
            control={control}
            errors={errors}
            options={inspectionOptions || []}
            disabled
          />
        </Grid>
        <Grid data-testid="priority" size={2}>
          <SelectField
            id="assignmentHandling.priority"
            name="assignmentHandling.priority"
            label="Priority Level"
            required
            control={control}
            errors={errors}
            options={[
              { title: 'Low', value: 'low' },
              { title: 'Medium', value: 'medium' },
              { title: 'High', value: 'high' },
            ]}
            disabled
          />
        </Grid>
        <Grid data-testid="language" size={4}>
          <SelectField
            id="assignmentHandling.preferredLanguage"
            name="assignmentHandling.preferredLanguage"
            label="Preferred Language"
            required
            control={control}
            errors={errors}
            options={[
              { title: 'English', value: 'English' },
              { title: 'Spanish', value: 'Spanish' },
            ]}
            disabled
          />
        </Grid>
        <Grid data-testid="slo" size={2}>
          <SelectField
            id="assignmentHandling.SLO"
            name="assignmentHandling.SLO"
            label="SLO (Days)"
            required
            control={control}
            errors={errors}
            options={[...sloOptions()]}
            disabled
          />
        </Grid>
      </Grid>
      <Grid>
        <Grid container spacing={2} marginBottom={2} alignItems="baseline">
          <Grid size={3}>
            <TextField
              id="claim.peril"
              name={
                matchingPeril !== undefined
                  ? 'matchingPeril.title'
                  : 'claim.peril'
              }
              defaultValue={
                matchingPeril !== undefined
                  ? matchingPeril.title
                  : taskData?.claim?.peril || ''
              }
              label="Peril"
              inputProps={{ disabled: true }}
              control={control}
              errors={errors}
              disabled
            />
          </Grid>
          <Grid size={3}>
            <SelectField
              id="assignment.assignmentType"
              name="assignmentHandling.assignmentType"
              label="Assignment Type"
              control={control}
              errors={errors}
              disabled
              options={[
                {
                  title: 'Property - Structure',
                  value: 'propertyStructure',
                },
                { title: 'Property - Contents', value: 'propertyContents' },
              ]}
            />
          </Grid>
          <Grid size={3}>
            <SelectField
              id="assignment.assignmentCategory"
              name="assignmentHandling.assignmentCategory"
              label="Assignment Category"
              control={control}
              errors={errors}
              disabled
              options={[
                { title: 'Initial', value: 'initial' },
                { title: 'Supplement', value: 'supplement' },
              ]}
              readOnly={!hasUpsertPermissions}
            />
          </Grid>
          <Grid size={3}>
            <SelectField
              id="assignment.inspectionType"
              name="assignmentHandling.inspectionType"
              label="Inspection Type"
              control={control}
              errors={errors}
              disabled
              options={[
                { title: 'Inspect Only', value: 'inspectOnly' },
                { title: 'Settle', value: 'settle' },
              ]}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        <Grid container spacing={2} alignItems="baseline">
          <Grid size={3}>
            <TextField
              id="claim.catCode"
              name="claim.catCode"
              label="CAT Code"
              inputProps={{ disabled: true }}
              control={control}
              errors={errors}
              disabled
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        <Grid container spacing={2} alignItems="baseline">
          <Grid size={4}>
            <CheckBoxField
              control={control}
              id="assignmentHandling.isStateLicenseRequired"
              name="assignmentHandling.isStateLicenseRequired"
              label="State License Required"
              disabled
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
